let list = [
    {
        info:{
            "id": "1",
            "Description": "Software development involves coding, testing, debugging, and deploying applications for various platforms and users.",
            "Statstics": "200000",
            "Date": "11 july  2024",
            "Time": "4:15 AM",
            "Action": "Edit/Delete",
        }
    },
    {
        info:{
            "id": "2",
            "Description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut.",
            "Statstics": "90000",
            "Date": "25 June 2024",
            "Time": "06:45 PM",
            "Action": "Edit/Delete",
        }
    },
    {
        info:{
            "id": "3",
            "Description": "In data science, analyzing and visualizing data helps to derive meaningful insights for decision-making.",


            "Statstics": "470000",
            "Date": "13 Dec 2024",
            "Time": "3:15 AM",
            "Action": "Edit/Delete",
        }
    },
    {
        info:{
            "id": "4",
            "Description": "Software development involves coding, testing, debugging, and deploying applications for various platforms and users.",
            "Statstics": "15000",
            "Date": "12 Nov 2024",
            "Time": "9:15 PM",
            "Action": "Edit/Delete",
        }
    },
    {
        info:{
            "id": "5",
            "Description": "Software development involves coding, testing, debugging, and deploying applications for various platforms and users.",
            "Statstics": "670000",
            "Date": "2 Jan 2024",
            "Time": "6:05 aM",
            "Action": "Edit/Delete",
        }
    },
    {
        info:{
            "id": "6",
            "Description": "Software development involves coding, testing, debugging, and deploying applications for various platforms and users.",
            "Statstics": "200000",
            "Date": "11 july  2024",
            "Time": "4:15 AM",
            "Action": "Edit/Delete",
        }
    },
    {
        info:{
            "id": "7",
            "Description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut.",
            "Statstics": "90000",
            "Date": "25 June 2024",
            "Time": "06:45 PM",
            "Action": "Edit/Delete",
        }
    },
    {
        info:{
            "id": "8",
            "Description": "In data science, analyzing and visualizing data helps to derive meaningful insights for decision-making.",


            "Statstics": "470000",
            "Date": "13 Dec 2024",
            "Time": "3:15 AM",
            "Action": "Edit/Delete",
        }
    },
    {
        info:{
            "id": "9",
            "Description": "Software development involves coding, testing, debugging, and deploying applications for various platforms and users.",
            "Statstics": "15000",
            "Date": "12 Nov 2024",
            "Time": "9:15 PM",
            "Action": "Edit/Delete",
        }
    },
    {
        info:{
            "id": "10",
            "Description": "Software development involves coding, testing, debugging, and deploying applications for various platforms and users.",
            "Statstics": "670000",
            "Date": "2 Jan 2024",
            "Time": "6:05 aM",
            "Action": "Edit/Delete",
        }
    },
    {
        info:{
            "id": "11",
            "Description": "Software development involves coding, testing, debugging, and deploying applications for various platforms and users.",
            "Statstics": "200000",
            "Date": "11 july  2024",
            "Time": "4:15 AM",
            "Action": "Edit/Delete",
        }
    },
    {
        info:{
            "id": "12",
            "Description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut.",
            "Statstics": "90000",
            "Date": "25 June 2024",
            "Time": "06:45 PM",
            "Action": "Edit/Delete",
        }
    },
    {
        info:{
            "id": "13",
            "Description": "In data science, analyzing and visualizing data helps to derive meaningful insights for decision-making.",


            "Statstics": "470000",
            "Date": "13 Dec 2024",
            "Time": "3:15 AM",
            "Action": "Edit/Delete",
        }
    },
    {
        info:{
            "id": "14",
            "Description": "Software development involves coding, testing, debugging, and deploying applications for various platforms and users.",
            "Statstics": "15000",
            "Date": "12 Nov 2024",
            "Time": "9:15 PM",
            "Action": "Edit/Delete",
        }
    },
    {
        info:{
            "id": "15",
            "Description": "Software development involves coding, testing, debugging, and deploying applications for various platforms and users.",
            "Statstics": "670000",
            "Date": "2 Jan 2024",
            "Time": "6:05 aM",
            "Action": "Edit/Delete",
        }
    },
    {
        info:{
            "id": "16",
            "Description": "Software development involves coding, testing, debugging, and deploying applications for various platforms and users.",
            "Statstics": "200000",
            "Date": "11 july  2024",
            "Time": "4:15 AM",
            "Action": "Edit/Delete",
        }
    },
    {
        info:{
            "id": "17",
            "Description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut.",
            "Statstics": "90000",
            "Date": "25 June 2024",
            "Time": "06:45 PM",
            "Action": "Edit/Delete",
        }
    },
    {
        info:{
            "id": "18",
            "Description": "In data science, analyzing and visualizing data helps to derive meaningful insights for decision-making.",


            "Statstics": "470000",
            "Date": "13 Dec 2024",
            "Time": "3:15 AM",
            "Action": "Edit/Delete",
        }
    },
    {
        info:{
            "id": "19",
            "Description": "Software development involves coding, testing, debugging, and deploying applications for various platforms and users.",
            "Statstics": "15000",
            "Date": "12 Nov 2024",
            "Time": "9:15 PM",
            "Action": "Edit/Delete",
        }
    },
    {
        info:{
            "id": "20",
            "Description": "Software development involves coding, testing, debugging, and deploying applications for various platforms and users.",
            "Statstics": "670000",
            "Date": "2 Jan 2024",
            "Time": "6:05 aM",
            "Action": "Edit/Delete",
        }
    }     
]
export default list;